import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

export const HotelCenterOverview = globalContext.define(
  [
    '@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center',
    '@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center-shared',
    'PageContext',
    'campaignui/feature/bulk-operation/edit-detail/detail-mapper',
    'campaignui/feature/bulk-operation/util/bulk-edit-job',
    'campaignui/feature/griddownload/view/adapter',
    'campaignui/feature/hotel-center-edm/index',
    'campaignui/feature/hotel-center-js-data/index',
    'component/bingads-grid/plugin/column-chooser',
    'component/bingads-grid/plugin/cross-page-select-all/index',
    'component/bingads-grid/plugin/new-performance-log',
    'component/bingads-grid/shared/column',
    'component/bingads-grid/shared/schema-util',
    'component/config/index',
    'component/grid-customized-popup-editor/index',
    'component/humanize/decimal',
    'component/state/index',
    'component/toast/index',
    'component/preference/service/index',
    '$/schema-i18n!hotel-center',
    'component/js-data-campaign/index',
    '@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center-utils',
    'component/bingads-grid/service/date-filter-preferences',
    'component/bingads-grid/service/segmentation-preferences',
    'component/bingads-grid/service/column-chooser-preferences',
  ],
  Promise => Promise.all([import(/* webpackMode: 'eager' */ './src/hotel-center-overview'),
  import(/* webpackMode: 'eager' */ './src/bulk-edit/bulk-edit-bid-panel'),
  import(/* webpackMode: 'eager' */ './src/bulk-edit/bulk-edit-bid-multi-panel'),
  import(/* webpackMode: 'eager' */ './src/bulk-edit/increase-decrease-bid-panel'),
  ]) // eslint-disable-line no-unused-vars
);

